import React, { useState, useEffect } from "react";
import {
  Badge,
  Form,
  Row,
  Col,
  Button,
  Alert,
  Spinner,
  Card,
} from "react-bootstrap";
import Sidebar from "../components/SidebarRegistration";
import _ from "underscore";
import ErrorMdl from "../components/errorMdl";
import PriceListMdl from "../components/personal/PriceList";
import { useAuth } from "./../context/auth";
import { updateTokens } from "./../context/checkTokens";

//Todo: get pkey from above and use it
const axios = require("axios");

const SubscriptionFreeTrial = (props) => {
  const { authTokens, setAuthTokens } = useAuth();

  const [hasError, setErrors] = useState(false);
  const [errorshow, setErrorShow] = useState(false);
  const [show, setShow] = useState(false);
  const [data, setData] = useState({});
  const [dataexpiry, setDataExpiry] = useState("");
  const [sid, setSession] = useState("");
  const [loading, setLoading] = useState(true);
  /**
   * fecthcheckoutsession
   */
  async function setProtrial() {
    axios
      .get(
        !_.isUndefined(process.env.REACT_APP_API_URL)
          ? process.env.REACT_APP_API_URL + "/Auth/Protrial"
          : "/Auth/Protrial",
        {
          withCredentials: true,
        }
      )

      .then((res) => {
        if (res?.data && res?.data?.success === 1) {
          //   document.body.classList.add("pro-user");
          setAuthTokens(updateTokens(authTokens, "pro_trial", "1"));
          //   window.location.href = "/Subscription";
          // } else {
          window.location.href = "/SubscriptionFreeTrial";
        }
      })
      .catch((error) => {
        if (!_.isEmpty(error)) setErrors(error);
      });
  }
  async function fetchExpiry() {
    axios
      .get(
        !_.isUndefined(process.env.REACT_APP_API_URL)
          ? process.env.REACT_APP_API_URL + "/Auth/getSubscriptionExpiry"
          : "/Auth/getSubscriptionExpiry",
        {
          withCredentials: true,
        }
      )

      .then((res) => {
        setDataExpiry(res.data);
      })
      .catch((error) => {
        if (!_.isEmpty(error)) setErrors(error);
      });
  }

  useEffect(() => {
    document.body.classList.remove("homepage");
    if (!_.isUndefined(props.isPro) ? props.isPro : false)
      document.body.classList.add("pro-user");
    else document.body.classList.add("free-user");
    fetchExpiry();
    //setPublicKey(key.PublicKey);
    //console.log(key);
  }, []);

  const handleClick = async (event) => {
    // Call your backend to create the Checkout session.
    await setProtrial();
  };
  //
  // dateFormat(row.createdAt, "dd/mm/yyyy H:M:s")
  return (
    <main role="main" className="main mt-2 container-fluid">
      <Row></Row>
      {hasError ? (
        <Alert variant="danger">You must login to access this page!</Alert>
      ) : (
        <Row>
          <Col md="3">
            <Sidebar {...props} />
          </Col>
          <Col md="9">
            {props.isPro !== true && authTokens?.pro_trial == 0 && (
              <Card>
                <Card.Body>
                  <Card.Header className="label label-success">
                    <h2>Get PRO</h2>{" "}
                    <span className="pro-label">free two weeks trial</span>
                  </Card.Header>
                  <p>
                    {" "}
                    Unlock all Pro features for two full weeks. No payment
                    required – just explore and make the most of your trial!
                  </p>

                  <Button className="btn btn-default" onClick={handleClick}>
                    Activate Free Trial
                  </Button>
                  <br></br>
                </Card.Body>
              </Card>
            )}

            {props.isPro !== 1 && authTokens?.pro_trial == 1 && (
              <Card>
                <Card.Body>
                  {" "}
                  <Card.Header className="label label-warning">
                    Check your email and follow the instructions to activate
                    your Free trial.<br></br>
                    <Button className="btn btn-default" onClick={handleClick}>
                      Resend Verification Email
                    </Button>
                  </Card.Header>{" "}
                </Card.Body>
              </Card>
            )}

            {props.isPro !== true && authTokens?.pro_trial == 2 && (
              <Card>
                <Card.Body>
                  {" "}
                  <Card.Header className="label label-warning">
                    Free Trial already used!
                  </Card.Header>{" "}
                  <br></br>
                  {dataexpiry && (
                    <div
                      className="mb-2 alert alert-info"
                      role="alert"
                      dangerouslySetInnerHTML={{ __html: dataexpiry.message }}
                    ></div>
                  )}
                </Card.Body>
              </Card>
            )}
          </Col>
        </Row>
      )}
      <ErrorMdl error={hasError} setErrorShow={setErrorShow} show={errorshow} />
      <PriceListMdl setShow={setShow} show={show}></PriceListMdl>
    </main>
  );
};

export default SubscriptionFreeTrial;
